import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

import * as PlantillaGeneralService from 'services/plantillaGeneralContabilidad.service'

const PlantillaFormGroup = ({ vOrigen, iError, iTouched, fIsSubmitting, setFieldValue }) => {
  const [plantillas, setPlantillas] = React.useState([])

  React.useEffect(() => {
    if (vOrigen === '') {
      setPlantillas([])
    } else {
      PlantillaGeneralService.getxOrigenAsSelect(vOrigen).then(({ data }) => {
        setPlantillas(data)
        if (data.length > 0) {
          const first = data[0]
          setFieldValue('_idPlantilla', first._id)
        }
      })
    }
  }, [vOrigen, setFieldValue])

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('inputselect-glosa', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='PLANTILLA' htmlFor='select-plantilla' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idPlantilla'>
          {({ field }) => (
            <Form.Select
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
              id='select-plantilla'
            >
              <option value=''>Seleccionar</option>
              {plantillas.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.titulo}
                </option>
              ))}
              <option value='NO_ID'>-- Sin plantilla --</option>
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PlantillaFormGroup)
